import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

if (process.env.NODE_ENV === 'production') {
  console.log = () => { };
  console.warn = () => { };
  console.error = () => { };
  console.info = () => { };
  console.debug = () => { };
}

// Reescreve o path antes do React montar, eliminando qualquer flash de tela errada.
// O BrowserRouter vai enxergar já o path correto no primeiro render.
(function rewritePathByHostname() {
  const host = window.location.hostname;
  const path = window.location.pathname;

  if (host.startsWith('med.')) {
    // /previa/:urlSlug é rota pública compartilhada (prévia de apostila, sem
    // login) — um link clicado direto (nova aba, WhatsApp etc.) chega aqui
    // sem nenhum contexto Ryan ainda estabelecido. Forçar /ryan/previa/...
    // quebrava o link: esse path não bate com nenhuma rota registrada e cai
    // no catch-all /ryan/*, que renderiza a Home em vez da prévia.
    if (!path.startsWith('/ryan') && !path.startsWith('/previa/')) {
      const newPath = path === '/' ? '/ryan' : '/ryan' + path;
      window.history.replaceState(null, '', newPath + window.location.search + window.location.hash);
    }
    return;
  }

  if (host.startsWith('lucasegiovana.')) {
    if (path === '/' || path === '') {
      window.history.replaceState(null, '', '/lista-presentes');
    }
  }
})();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <App />
);

reportWebVitals();